import { HISTORICAL, PROJECTED } from 'common/constants/financials';
import { Z_INDEX_FOR_ADD_BUTTONS } from 'components/Buttons/constants';
import {
  APP_DRAGGABLE_DRAWER_HEIGHT_VAR,
  MIN_DRAWER_HEIGHT,
} from 'components/Drawer/draggable-drawer/DraggableDrawer.constants';
import { FloatingButtonGroup } from 'components/FloatingButtonGroup';
import { FinancialsButtonsProps } from './FinancialsButtons.props';

const FinancialsButtons = ({ addFinancialYear, isDisabled }: FinancialsButtonsProps) => (
  <FloatingButtonGroup
    style={{
      marginBottom: `var(${APP_DRAGGABLE_DRAWER_HEIGHT_VAR}, ${MIN_DRAWER_HEIGHT}px)`,
      zIndex: Z_INDEX_FOR_ADD_BUTTONS,
    }}
    id="financials-add-historical-year-btn"
    disabled={isDisabled}
    mainAction={{
      key: 'fund-ownership-add-btn',
      label: PROJECTED,
      onClick: () =>
        addFinancialYear({
          isPrevYear: false,
        }),
    }}
    secondaryActions={[
      {
        key: 1,
        label: HISTORICAL,
        onClick: () =>
          addFinancialYear({
            isPrevYear: true,
          }),
      },
    ]}
  />
);

export default FinancialsButtons;
